import {Sync} from '@client/sync'

export const getUsersList = (): string[] => {
  const box = Sync.getCurrentSandbox()
  return box.getAllUsers(false).map(u => u.email)
}
